import { Hours } from '../features/schedule/types';

const isFiniteNumber = (value: unknown): value is number =>
    typeof value === 'number' && Number.isFinite(value);

const normalizeHours = (value: unknown, fallback: Hours): Hours => {
    const source = value && typeof value === 'object'
        ? value as Partial<Hours> & { plannedHours?: number | null }
        : {};

    const planned = isFiniteNumber(source.planned)
        ? source.planned
        : isFiniteNumber(source.plannedHours)
            ? source.plannedHours
            : fallback.planned ?? 0;

    return {
        totalHours: isFiniteNumber(source.totalHours) ? source.totalHours : fallback.totalHours,
        approved: isFiniteNumber(source.approved) ? source.approved : fallback.approved,
        billed: isFiniteNumber(source.billed) ? source.billed : fallback.billed,
        workHours: isFiniteNumber(source.workHours) ? source.workHours : fallback.workHours,
        absenceHours: isFiniteNumber(source.absenceHours) ? source.absenceHours : fallback.absenceHours,
        planned
    };
};

export const TIMESHEET_SUMMARY_STORAGE_KEYS = [
    'timesheet.summary.v1',
    'timesheet.mobile-summary.v1',
    'timesheet.mobile-summary',
    'timesheet.summary'
];

export const TIMEREPORT_SUMMARY_STORAGE_KEYS = [
    'timereport.summary.v1',
    'timereport.mobile-summary.v1',
    'timereport.mobile-summary',
    'timereport.summary'
];

export const readPersistedSummary = (storageKeys: string[], fallback: Hours): Hours => {
    if (typeof window === 'undefined') {
        return fallback;
    }

    for (const storageKey of storageKeys) {
        const raw = window.localStorage.getItem(storageKey);
        if (!raw) {
            continue;
        }

        try {
            return normalizeHours(JSON.parse(raw), fallback);
        } catch {
            continue;
        }
    }

    return fallback;
};

export const persistSummary = (storageKey: string, hours: Hours): void => {
    if (typeof window === 'undefined') {
        return;
    }

    try {
        window.localStorage.setItem(storageKey, JSON.stringify(normalizeHours(hours, hours)));
    } catch {
        //
    }
};
